
define('template!dropdownItemTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<a class="dropdown__item-link">' +
((__t = ( label )) == null ? '' : __t) +
'</a>';

}
return __p
};});

